import { Injectable } from "@angular/core";
import { ConfigService } from "../config/config.service";
import { CustomerModel } from "src/app/models/customer-model";
import { UserSessionService } from "../user-session/user-session.service";
import { WebservicesService } from "../webservices/webservices.service";
import { ReplaySubject, Subject } from "rxjs";
import type { PlatformResponse } from "src/app/interfaces/webservices-interface";
import { MenuItemPreProcessor } from "../cashier/menu-item-pre-processor-helper.service";
import { HttpClient } from "@angular/common/http";
import { WithdrawalService } from "../cashier/withdrawal.service";
import { LoyaltyProgramProvider } from "../loyalty-program/loyalty-program.service";



@Injectable({
  providedIn: "root",
})

export class SidemenuService {
  private customer: CustomerModel;
  menuOpts: any;
  menuCached: boolean = false;
  public menuItemsSubject: Subject<[]>;

  constructor(
    private userSession:UserSessionService,
    private webService: WebservicesService,
    private withdrawService:WithdrawalService,
    private loyaltyProgramProvider:LoyaltyProgramProvider,
    private http:HttpClient,
    private config: ConfigService,
  ) {
    this.menuItemsSubject = new ReplaySubject(1);
    this.userSession.getCustomer().subscribe(
      (customer) => {
        this.customer = customer;
      }
    );
  }

  setMenuData(data) {
    this.menuItemsSubject.next(data);
  }

  getMenuData() {
    return this.menuItemsSubject;
  }



  init(menuSelected){
      this.getSidemenuData(menuSelected);
  }

  getSidemenuData(menuSelected) {
    if(!this.menuOpts){
        const siteMenuFile = this.config.getConfig().SITE_MENU_FILE;
        let menuParsed;
    
        try {
          menuParsed = JSON.parse(siteMenuFile);
        } catch (e) {
          menuParsed = JSON.parse(
            `{"right": "${siteMenuFile}", "left": "${siteMenuFile}" }`
          );
        }
    
        let selectedLink = menuSelected === "right" ? menuParsed.right : menuParsed.left;
    
        let menu_url = this.config.loadCDNAsset(selectedLink);
    
        return this.http.get(menu_url).toPromise().then((res: any) => {
              this.menuOpts = res;
              this.setMenuData(this.menuOpts);
            },
            (err) => console.error(err)
          );
    }else {
        this.menuCached = true;
        return this.menuOpts;
    }

  }

  getMenuCacheStatus(){
    if(this.menuCached){
      return true;
    }else {
      return false;
    }
  }

  reIterateMenu(){
    const menuItemPreProcessor = new MenuItemPreProcessor(
      this.withdrawService, this.loyaltyProgramProvider, this.config
    );

    const filteredMenuOpts = this.menuOpts.filter((menuItem) => {
      return true;
    })

    filteredMenuOpts.forEach((menuItem) => {
      menuItemPreProcessor.menuItemPreProcessing(menuItem);
    });

    this.setMenuData(filteredMenuOpts);
    return filteredMenuOpts;
  }


 
}
